import React, {Fragment} from "react";

const declaration_url = process.env.REACT_APP_DECLARATION_LINK;
const terms_and_conditions_url = process.env.REACT_APP_T_AND_C_LINK;

export default class OutboundDeclarationComponent extends React.Component {

    render() {
        return <Fragment>
            {this.props.className === 'mobile' ? this.renderContent('mobile') : this.renderContent('browser')}
        </Fragment>
    }

    renderContent(className) {
        let bopDescription = ""
        if (this.props.quoteBopCategory !== "") {
            bopDescription = " as BOP Code " + this.props.quoteBopCategory.reportingCode + " - " + this.props.quoteBopCategory.outboundDescription;
        }
        return <div className={className + "_declaration_screen"}>
            <ul>
                By acceptance of this quotation, you are confirming your transaction will be reported
                {bopDescription}. For more information, please view the
                <a href={declaration_url}
                   target="_blank" rel="noopener noreferrer"> Declaration </a>and
                <a href={terms_and_conditions_url}
                   target="_blank" rel="noopener noreferrer"> Terms and Conditions</a>
            </ul>
        </div>
    }
}
